import { getPathName, getButtonLinkProps, ROUTES } from '@openclassrooms/routing';
import type { FundingType } from '@openclassrooms/sdk-web';

export const getAdmissionFunnelUrl = (
  appsource: string,
  pathId?: number,
  fundingType?: FundingType
) => {
  const pathQuery = pathId ? `&pathId=${pathId}` : '';
  const fundingQuery = fundingType ? `&fundingType=${fundingType}` : '';
  return `${getPathName(
    ROUTES.APPLICATION.WELCOME
  )}?appsource=${appsource}${pathQuery}${fundingQuery}`;
};

export const getAdmissionFunnelLinkProps = (
  appsource: string,
  pathId?: number,
  fundingType?: FundingType
) => {
  const query = {
    appsource,
    ...(pathId ? { pathId: String(pathId) } : {}),
    ...(fundingType ? { fundingType } : {}),
  };
  return getButtonLinkProps(ROUTES.APPLICATION.WELCOME, { query });
};
